<template>
  <span>
    <modal @close="$emit('close')">
      <h4 slot="title">{{ 'Change Password' }}</h4>
      <section
        slot="body"
        class="popup-section-body"
      >
        <editable-input
          id="old-password-wrapper"
          v-model="oldPassword"
          :title="$t('oldPassword')"
          reference="oldPassword"
          input-type="password"
          :autofocus="true"
        />
        <editable-input
          id="new-password-wrapper"
          v-model="newPassword"
          :title="$t('newPassword')"
          input-type="password"
          :validation-function="passwordValid"
        />
        <p class="description">{{ $t('passwordMustBeAtLeast') }}</p>
        <button
          id="change-button"
          class="clavo-button primary"
          :class="{ 'clavo-button-inactive': !formValid }"
          @click="change"
        >
          {{ $t('changePassword') }}
        </button>
      </section>
    </modal>
  </span>
</template>

<script>
import Modal from '@/components/Modal'
import EditableInput from '@/components/UI/EditableInput'
import ParseFunctions from '@/components/ParseFunctions'
import Constants from '@/components/Constants'
import Validation from '@/components/Validation'
import Parse from 'parse'

export default {
  components: {
    Modal,
    EditableInput,
  },
  mixins: [ParseFunctions, Constants, Validation],
  data() {
    return {
      oldPassword: '',
      newPassword: ''
    }
  },
  computed: {
    formValid() {
      return this.passwordValid(this.newPassword)
    },
  },
  methods: {
    async change() {
      if (this.formValid) {
        let res = await this.changePassword(this.oldPassword, this.newPassword)
        if (res.status === 'ok') {
          await Parse.User.logIn(Parse.User.current().get('email'), this.newPassword)
          this.$emit('password-changed', res.status, res.error)
        } else {
          this.showServerError(res)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: column;
  gap: 24px;

  p {
    text-align: left;
    padding: 0;
    color: $bluebell;
  }

  .disabled {
    color: $bluebell;
  }

  #change-button {
    margin-top: 40px;
  }
}
</style>
